export default "__VITE_ASSET__d9740667__"